'use client'
import React, { useState } from 'react';
import Image from 'next/image';
import '@/app/main.css';

const faqs = [
  {
    question: "What types of games do you develop?",
    answer: "We develop a wide range of games including casual, hyper-casual, puzzle, arcade, and multiplayer games. Whether it's a simple time-killer or a complex real-time game, our team can bring your concept to life."
  },
  {
    question: "Can you build apps for both Android and iOS?",
    answer: "Yes, we offer cross-platform app development for Android and iOS using technologies like Flutter and React Native. We also build native apps for clients who prefer platform-specific performance."
  },
  {
    question: "I have a game idea but no technical knowledge. Can you help?",
    answer: "Absolutely! You just share your idea — we’ll handle everything from concept design, development, testing, to launch. We also guide you through monetization, user acquisition, and app store publishing."
  },
  {
    question: "How long does it take to develop a game or app?",
    answer: "Timeframes vary depending on complexity. A basic app or casual game may take 4–6 weeks, while more advanced or feature-rich projects could take 2–3 months. We’ll give you a clear timeline after discussing your requirements."
  },
  {
    question: "Do you provide ongoing support after launch?",
    answer: "Yes, we offer complete post-launch support including bug fixes, updates, feature additions, and performance monitoring. Our goal is to ensure your game or app continues to run smoothly and grow over time."
  },
];

function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div>
      <div className='col text-center py-5 mt-5' data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
        <h3>FAQ's</h3>
      </div>

      {/* Shapes */}
      <Image src="/shape1.svg" width={202} height={202} alt="shape" className="shape1" />
      <Image src="/shape2.svg" width={22} height={22} alt="shape" className="shape2 rotateme" />

      <div className="faq-area ptb-20">
        <div className="container" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
          <div className="faq-accordion accordion">
            {faqs.map((item, index) => (
              <div key={index} className="accordion__item">
                <div
                  className="accordion__heading faq-heading"
                  role="heading"
                  aria-level="3"
                  data-aos="fade-up"
                  data-aos-delay="100"
                  data-aos-duration="500"
                  data-aos-once="true"
                >
                  <div
                    className="accordion__button"
                    role="button"
                    tabIndex={0}
                    onClick={() => toggleAccordion(index)}
                    aria-expanded={openIndex === index}
                    data-aos="fade-up"
                    data-aos-delay="100"
                    data-aos-duration="500"
                    data-aos-once="true"
                  >
                    <span>{item.question}</span>
                  </div>
                </div>
                {openIndex === index && (
                  <div
                    className="accordion__panel faq-ans"
                    data-aos="fade-up"
                    data-aos-delay="100"
                    data-aos-duration="500"
                    data-aos-once="true"
                  >
                    <p>{item.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default FaqSection;
